module.exports = __webpack_public_path__ + "d398b19d59b3c4e9685cc6ecbf89780b.svg";